import { render, staticRenderFns } from "./ContentEditor.vue?vue&type=template&id=e4f0cd78&scoped=true&"
import script from "./ContentEditor.vue?vue&type=script&lang=ts&"
export * from "./ContentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ContentEditor.vue?vue&type=style&index=0&id=e4f0cd78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f0cd78",
  null
  
)

export default component.exports